// extracted by mini-css-extract-plugin
export default {"header":"header__C7T8rf","sortIcons":"sortIcons__zvUNEZ","active":"active__R2Udu1"};